/* eslint-disable */
import * as Types from '../../../../../../types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
const defaultOptions = {} as const;
export type AuthQueryQueryVariables = Types.Exact<{
  permissions: Array<Types.RbacPermissionType> | Types.RbacPermissionType;
}>;

export type AuthQueryQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    username: string;
    team?: {
      __typename?: 'Team';
      id: string;
      name?: string | null;
      ssoState: Types.TeamSsoState;
      settings: {
        __typename?: 'TeamSettings';
        divisionAdminsCanManageUsers: boolean;
      };
    } | null;
    teamMembership?: {
      __typename?: 'UserTeamMembership';
      id: string;
      isEnterprise: boolean;
      isAdmin: boolean;
      isDivisionAdmin: boolean;
      memberType: Types.TeamMemberType;
    } | null;
    language: { __typename?: 'Language'; id: string; code: string };
    package: { __typename?: 'UserPackage'; id: string; canonicalName: string };
    features: {
      __typename?: 'UserFeatureSet';
      teamsEnabled: boolean;
      workgroupsEnabled: boolean;
      adminDashboardEnabled: boolean;
      offlineEnterpriseEnabled: boolean;
      teamAudienceCreditsEnabled: boolean;
      auditLogsEnabled: boolean;
      divisionsEnabled: boolean;
      deiReporting: boolean;
    };
  } | null;
  rbacPermissions: Array<{
    __typename?: 'RbacPermission';
    permission: Types.RbacPermissionType;
    isAuthorized: boolean;
  }>;
};

export const AuthQueryDocument = gql`
  query authQuery($permissions: [RbacPermissionType!]!) {
    user {
      id
      username
      team {
        id
        name
        ssoState
        settings {
          divisionAdminsCanManageUsers
        }
      }
      teamMembership {
        id
        isEnterprise
        isAdmin
        isDivisionAdmin
        memberType
      }
      language {
        id
        code
      }
      package {
        id
        canonicalName
      }
      features {
        teamsEnabled
        workgroupsEnabled
        adminDashboardEnabled
        offlineEnterpriseEnabled
        teamAudienceCreditsEnabled
        auditLogsEnabled
        divisionsEnabled
        deiReporting
      }
    }
    rbacPermissions(permissions: $permissions) {
      permission
      isAuthorized
    }
  }
`;

/**
 * __useAuthQueryQuery__
 *
 * To run a query within a React component, call `useAuthQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthQueryQuery({
 *   variables: {
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useAuthQueryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AuthQueryQuery,
    AuthQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<AuthQueryQuery, AuthQueryQueryVariables>(
    AuthQueryDocument,
    options
  );
}
export function useAuthQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AuthQueryQuery,
    AuthQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<AuthQueryQuery, AuthQueryQueryVariables>(
    AuthQueryDocument,
    options
  );
}
export type AuthQueryQueryHookResult = ReturnType<typeof useAuthQueryQuery>;
export type AuthQueryLazyQueryHookResult = ReturnType<
  typeof useAuthQueryLazyQuery
>;
export type AuthQueryQueryResult = ApolloReactCommon.QueryResult<
  AuthQueryQuery,
  AuthQueryQueryVariables
>;
